import { render, staticRenderFns } from "./UsersPrivilegeEstablishmentYearSetting.vue?vue&type=template&id=08edebfe&scoped=true&"
import script from "./UsersPrivilegeEstablishmentYearSetting.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegeEstablishmentYearSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08edebfe",
  null
  
)

export default component.exports